<template>
  <div>
    <b-col md="12">
      <FilterTransactions
        class="mt-4 ml-3 mr-3"
        @onSubmitFilter="handleFilter"
        title="فیلتر برداشت های ناموفق"
        :fromAssets="$store.getters.getAvailableFiatAssets"
        :toAssets="$store.getters.getAvailableFiatAssets"
        :asset="true"
      />

      <card class="data-card mt-4 mr-3 ml-3" :show-footer-line="true">
        <b-row no-gutters>
          <b-col no-gutters>
            <h1 class="card-header">برداشت های ناموفق</h1>
          </b-col>
        </b-row>
        <b-skeleton-table
          v-if="loading"
          :rows="10"
          :columns="4"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>
        <b-row v-if="!loading">
          <b-col md="12">
            <!-- <h1 class="section-header">کیف های پول</h1> -->
            <b-card class="wallets-table" no-body>
              <b-table
                emptyText="تاریخچه ای یافت نشد"
                :items="histories"
                :fields="fields"
                show-empty
                responsive
                small
              >
                <template #cell(status)="row">
                  <b-button size="sm" variant="outline-primary">
                    {{ getText(row.item.status) }}
                  </b-button>
                </template>

                <template #cell(type)="row">
                  <b-button size="sm" variant="outline-primary">
                    {{ getText(row.item.type) }}
                  </b-button>
                </template>

                <template #cell(firstName)="row">
                  <b-link
                    :to="'/user-profile/' + row.item.accountId"
                    size="sm"
                    variant="outline-primary"
                  >
                    {{ row.item.firstName + " " + row.item.lastName }}
                  </b-link>
                </template>

                <template #cell(amount)="row">
                  {{ fixDecimal(row.item.amount) }} تومان
                </template>
                <template #cell(serviceFee)="row">
                  {{ fixDecimal(row.item.serviceFee) }}
                </template>

                <template #cell(asset)="row">
                  <div style="display: flex">
                    <CryptoIcons
                      v-if="row.item.asset"
                      class="ml-3"
                      :symbol="row.item.asset"
                      size="30"
                    />

                    <span class="pt-1">{{ row.item.asset }}</span>
                  </div>
                </template>

                <template #cell(date)="row">
                  {{ faDateTime(row.item.date) }}
                </template>

                <template #cell(actions)="row" v-if="isAdmin">
                  <b-button
                    size="sm"
                    variant="primary"
                    @click="$bvModal.show('modal-' + row.item.id)"
                  >توضیحات و فعالیت
                  </b-button>
                  <b-modal
                    :id="'modal-' + row.item.id"
                    title="توضیحات و فعالیت"
                  >
                    <template #default="{}">
                      <div class="text-right">
                        <h2>توضیحات:</h2>
                        <p class="my-4">{{ row.item.details }}</p>
                        <h2>توضیحات لغو یا تائید تراکنش:</h2>
                        <textarea
                          v-model="description"
                          class="w-100"
                        ></textarea>
                        <small
                        >نوشتن توضیحات برای تائید یا لغو تراکنش الزامی‌
                          است.</small
                        >
                      </div>
                    </template>
                    <template #modal-footer="{}">
                      <b-button
                        variant="success"
                        @click="
                          handleManualChangeStatus('approve', row.item.id)
                        "
                        :disabled="!description || description === ' '"
                      >
                        تائید تراکنش
                      </b-button>
                      <b-button
                        variant="danger"
                        @click="handleManualChangeStatus('reject', row.item.id)"
                        :disabled="!description || description === ' '"
                      >
                        لغو تراکنش
                      </b-button>
                    </template>
                  </b-modal>
                </template>
              </b-table>
            </b-card>
            <div class="paginationNav">
              <b-row>
                <b-col class="mt-4">
                  <BasePagination
                    :showNext="showNext"
                    :showPrev="currentPage !== 0"
                    @onClick="handlePaginationClick"
                  />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </card>
    </b-col>
  </div>
</template>

<script>

import http from "@/httpservices/HttpService"
import CryptoIcons from "@/components/CryptoIcons";
import FilterTransactions from "@/components/FilterTransactions";
import BasePagination from "@/components/BasePagination.vue";
import filterAndPaginate from "@/mixins/filterAndPaginate";
import store from "@/store"
import dateHelper from "@/utils/DateHelper";

export default {
  mixins: [filterAndPaginate],
  components: {
    CryptoIcons,
    FilterTransactions,
    BasePagination,
  },
  data() {
    return {
      description: "",
      fields: [
        {
          key: "type",
          label: "نوع",
          sortDirection: "desc",
          class: "text-right",
        },
        {
          key: "firstName",
          label: "کاربر",
          class: "text-center",
        },
        {
          key: "asset",
          label: "ارز",
          sortDirection: "desc",
          class: "text-center",
        },
        {
          key: "date",
          label: "تاریخ",
          sortable: true,
          class: "text-center",
        },
        {
          key: "status",
          label: "وضعیت",
          sortable: true,
          class: "text-center",
        },
        {
          key: "serviceFee",
          label: "هزینه تراکنش",
          sortable: true,
          class: "text-center",
        },
        {
          key: "amount",
          label: "مقدار",
          class: "text-center",
        },
        // {
        //   key: "details",
        //   label: "توضیحات",
        //   class: "text-center"
        // },

        {key: "actions", label: "توضیحات و فعالیت", class: "text-center"},
      ],
      histories: [],
      loading: false,

      userBoxArrow: "chevron-down",
    };
  },

  computed: {
    isAdmin() {
      const access = Boolean(store.getters['isSuperAdmin'] || store.getters['isManagerAdmin']);
      if (!access) {
        this.fields.pop();
      }
      return access;
    }
  },

  mounted() {
    this.toggle_icon();
    this.getHistory();
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      this.description = "";
    });
  },

  methods: {
    faDateTime(d) {
      return dateHelper.faDateTime(d);
    },

    handleManualChangeStatus(type, id) {
      this.loading = true;

      http.put(`/Bank/withdrawal/${id}/${type}`, {
        description: this.description,
      })
        .then(() => {
          this.loading = false;
          this.$bvModal.hide("modal-" + id);
          this.description = "";
          this.$swal({
            position: "center",
            icon: "success",
            title: "تغیر وضعیت تراکنش با موفقیت انجام شد.",
            showConfirmButton: false,
            timer: 1500,
          });
          this.getHistory();
        })
        .catch((err) => {
          this.loading = false;
          this.$swal({
            position: "center",
            icon: "error",
            title: "مشکلی پیش آمده، دوباره امتحان کنید.",
            showConfirmButton: false,
            timer: 1500,
          });
          let errorResponse = this.errorHandler(err);
        });
    },

    getHistory() {
      this.loading = true;

      http.get(`/AdminReports/open-withdrawals/${this.$route.params.id}/page/${this.currentPage}`, {
        params: {
          Start: this.filterData.fromDate,
          End: this.filterData.toDate,
          Symbol: this.filterData.symbol,
          PageSize: this.filterData.pageSize,
        }
      })
        .then((response) => {
          this.histories = [];

          if (this.$route.params.symbol != undefined) {
            response.data.data.forEach((element) => {
              if (element.toAsset == this.$route.params.symbol) {
                this.histories.push(element);
              }
            });
          } else {
            this.histories = response.data.data;
          }

          this.histories = this.setAssetToHistories(this.histories);

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          let errorResponse = this.errorHandler(err);
          //console.log(err);
          //this.$router.push("/500");
        });
    },

    getText(text) {
      if (text == "BankDeposit") {
        return "واریز بانکی";
      }

      if (text == "Open") {
        return "در حال پردازش/کنسل شده";
      }

      if (text == "BankWithdrawal") {
        return "برداشت بانکی";
      }

      if (text == "Filled") {
        return "تکمیل شده";
      }

      if (text == "Cancelled") {
        return "لغو شده";
      }
    },

    toggle_icon() {
      this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
        if (isJustShown == true) {
          this.userBoxArrow = "chevron-up";
        } else {
          this.userBoxArrow = "chevron-down";
        }
      });
    },
  },
};
</script>


<style lang="scss">
.card-detail-container {
  .modal-header .close {
    margin: -1rem -1rem -1rem -1rem;
  }

  .row {
    margin-bottom: 18px;
  }

  .last {
    margin-bottom: 0;
  }

  .info {
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #757575;
    text-align: right;
    margin-bottom: 8px;
  }

  .value {
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #000;
    text-align: left;
  }
}

.bank-logo {
  width: 34px;
  height: 34px;
}

.more-info-header-button {
  background-color: #fff;
}
</style>

<style lang="scss" scoped>
@media (max-width: 990px) {
  .section-header {
    font-size: 24px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #757575;
    margin-bottom: 49px;
  }
}

@media (min-width: 990px) {
  .card-header {
    text-align: right;
    font-size: 20px;
    padding: 0;
    padding-bottom: 16px;
  }

  .section-header {
    font-size: 24px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #757575;
    margin-bottom: 49px;
  }
}

.data-card {
  @media (max-width: 991px) {
    margin-top: 16px;
  }
}

#add-card-modal {
  .modal-body {
    text-align: right;
    direction: rtl;
  }
}
</style>
